import { useEffect, useRef, useState } from 'react';
import { pushEventToast } from '@/components/toasts/eventToastAtom';

const SEQ = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];

export function KonamiMatrix() {
  const [active, setActive] = useState(false);
  const idx = useRef(0);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const want = SEQ[idx.current];
      if (e.key.toLowerCase() === want.toLowerCase() || e.key === want) {
        idx.current += 1;
        if (idx.current === SEQ.length) {
          idx.current = 0;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            pushEventToast({ kind: 'server', title: 'SC Labs', sub: 'The eye sees you. (motion reduced)' });
          } else {
            setActive(true);
          }
        }
      } else {
        idx.current = e.key === SEQ[0] ? 1 : 0;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    if (!active) return;
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext('2d')!;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const cols = Math.floor(canvas.width / 14);
    const drops = new Array(cols).fill(0).map(() => Math.random() * -50);
    const glyphs = 'SCLABS01アイウエオカキ◊◈△▽▢▣';
    let raf = 0;
    const draw = () => {
      ctx.fillStyle = 'rgba(3,5,9,0.10)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = '14px JetBrains Mono, monospace';
      for (let i = 0; i < cols; i++) {
        const ch = glyphs[Math.floor(Math.random() * glyphs.length)];
        const x = i * 14;
        const y = drops[i] * 14;
        ctx.fillStyle = Math.random() > 0.975 ? '#d8f0ec' : '#00ffd1';
        ctx.fillText(ch, x, y);
        if (y > canvas.height && Math.random() > 0.975) drops[i] = 0;
        drops[i] += 1;
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    const stop = setTimeout(() => setActive(false), 6000);
    return () => { cancelAnimationFrame(raf); clearTimeout(stop); };
  }, [active]);

  if (!active) return null;
  return <canvas ref={canvasRef} className="sc-matrix" />;
}
